import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import style from "../../OrderInfoAviation.module.scss";
import LogoIcon from "../../../../shared/icons/LogoIcon";
import TenderIcon from "../../../../shared/icons/TenderIcon";
import UsersIcon from "../../../../shared/icons/UsersIcon";
import BoxIcon from "../../../../shared/icons/BoxIcon";
import HouseIcon from "../../../../shared/icons/HouseIcon";
import CheckCircleIcon from "../../../../shared/icons/CheckCircleIcon";
import PlaneIcon from "../../../../shared/icons/PlaneIcon";

const STATUS_TO_STEP = {
  moderation: 0,
  published: 0,
  awaitingoffer: 1,
  confirmed: 2,
  accepted: 3,
  onthetrip: 4,
  delivered: 5,
  completed: 6,
};

const STEPS = [
  { labelKey: "created", Icon: LogoIcon, size: 32 },
  { labelKey: "tender", Icon: TenderIcon, size: 20 },
  { labelKey: "confirmed", Icon: UsersIcon, size: 22 },
  { labelKey: "accepted", Icon: BoxIcon, size: 20 },
  { labelKey: "onTheWay", Icon: PlaneIcon, size: 20 },
  { labelKey: "delivered", Icon: HouseIcon, size: 20 },
  { labelKey: "completed", Icon: CheckCircleIcon, size: 22 },
];

const OrderInfoAviationStepper = ({ status, assignmentMethod }) => {
  const { t } = useTranslation();
  const currentStep = STATUS_TO_STEP[status] ?? 0;
  const progressPercent = (currentStep / (STEPS.length - 1)) * 100;

  return (
    <div className={style.stepper} aria-label={t("orderInfoAviation.stepper.label")}>
      <div className={style.stepper_container}>
        <div className={style.stepper_track} aria-hidden="true">
          <div className={style.stepper_track_progress} style={{ width: `${progressPercent}%` }} />
        </div>
        {STEPS.map((step, index) => {
          const isReached = index <= currentStep;
          const isCurrent = index === currentStep;

          return (
            <div key={step.labelKey} className={style.stepper_step}>
              <div
                className={cn(style.stepper_step_icon, {
                  [style.stepper_step_icon_active]: isReached,
                  [style.stepper_step_icon_inactive]: !isReached,
                })}
              >
                <step.Icon
                  width={step.size}
                  height={step.size}
                  fill={step.Icon === HouseIcon ? "none" : isReached ? "white" : "#6D7885"}
                  color={isReached ? "white" : "#6D7885"}
                  type={step.Icon === LogoIcon ? 2 : 1}
                />
              </div>
              <span
                className={cn(style.stepper_step_label, {
                  [style.stepper_step_label_active]: isCurrent,
                  [style.stepper_step_label_inactive]: !isReached,
                })}
                aria-current={isCurrent ? "step" : undefined}
              >
                {t(
                  step.labelKey === "tender" && assignmentMethod === "Auction"
                    ? "orderInfoExpeditor.stepper.auction"
                    : `orderInfoAviation.stepper.${step.labelKey}`,
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderInfoAviationStepper;
